import {
  FetchProductsResponse, FetchProductsParams,
	FetchGasProductsParams
} from "@/components/Contractation/types/products";
import API from "../../../services/api";
import { EndpointsProducts } from "./endpoints";

export const fetchAvailableProducts = ({
	power,
	accessTariff,
	selfcons,
	cups,
	promotionalCode,
}: FetchProductsParams
) => {
	return new Promise<FetchProductsResponse>(async (resolve, reject) => {
		API.get<FetchProductsResponse>({
			endpoint: EndpointsProducts.Pricelist,
			searchParams: [
				'?power', '=', power,
				'&atr', '=', accessTariff,
				'&cups', '=', cups,
				selfcons ? `&selfcons=${selfcons}` : '',
				promotionalCode ? `&promocode=${promotionalCode.join(",")}` : '',
			].join(''), 
		})
		.then(res => {
			resolve(res.promise.data)
		})
		.catch(err => {
			reject(err);
		})
	})
}

export const fetchAvailableGasProducts = ({
  accessTariff,
  cups,
}: Pick<FetchProductsParams, "accessTariff" | "cups">
) => {
  return new Promise<FetchProductsResponse>(async (resolve, reject) => {
    API.get<FetchProductsResponse>({
      endpoint: EndpointsProducts.GasPricelist,
			versions: [2],
      searchParams: [
        // '?power', '=', power,
        '?atr', '=', accessTariff,
        '&cups', '=', cups,
      ].join(''),
    })
      .then(res => {
        resolve(res.promise.data)
      })
      .catch(err => {
        reject(err);
      })
  })
}

export default {
  fetchAvailableProducts,
  fetchAvailableGasProducts,
};


